import React from "react";
import { RoundBorderComponentContainer } from "@src/components/templates/layouts/round-border-component-container/round-border-component-container";
import {
  CONFIGURATIONS,
  OTA_UPDATE_VIEW as cssClassName,
  FIRMWARE,
  SETTINGS,
} from "../../../cloud-connect/ota-update/constants";
import OTANavbar from "../../molecules/ota-navbar/ota-navbar";
import styles from "./ota-update-view.module.scss";
import { OTAMachineHeader } from "@src/components/molecules/ota-machine-header/ota-machine-header";
import { useOtaUpdateView } from "./use-ota-update-view";
import OTAFirmware from "../ota-firmware/ota-firmware";
import OTAConfigurations from "../ota-configurations/ota-configurations";
import OTASettings from "../ota-settings/ota-settings";

const OtaUpdateView = () => {
  const { isLoading, otaActiveView, fetchCurrentFirmwareVersion } =
    useOtaUpdateView();

  const OTA_VIEW_CONFIG = {
    [FIRMWARE]: (
      <OTAFirmware fetchCurrentFirmwareVersion={fetchCurrentFirmwareVersion} />
    ),
    [CONFIGURATIONS]: <OTAConfigurations />,
    [SETTINGS]: <OTASettings />,
  };
  return (
    <div className={styles[cssClassName]}>
      {/* LEFT NAVIGATION */}
      <div className={styles[`${cssClassName}__left`]}>
        <OTANavbar />
      </div>

      {/* MAIN CONTENT */}
      <div className={styles[`${cssClassName}__main`]}>
        <RoundBorderComponentContainer key={otaActiveView}>
          <OTAMachineHeader isLoading={isLoading} />
          {OTA_VIEW_CONFIG[otaActiveView]}
        </RoundBorderComponentContainer>
      </div>

      {/* RIGHT SPACER */}
      <div className={styles[`${cssClassName}__right`]} />
    </div>
  );
};

export default OtaUpdateView;
